<div [class]="isDetailsOutside() ? 'details-outside' : 'details-inside'">
  <div [class.mt-2]="!isDetailsOutside()" class="schedule">
    @if (!isDetailsOutside()) {
      <div class="schedule-header">
        <div
          (click)="showDetails('DETAILS')"
          [class.active]="activeTab() === 'DETAILS'"
          class="schedule-btn schedule-btn_details text-center d-flex justify-content-center align-items-center cursor-pointer position-relative"
        >
          <span class="label">{{ 'OUTSOURCE_NOTICE.BTN' | translate }}</span>
        </div>
      </div>
    }
    @if (previewValue()) {
      <div class="schedule-container">
        @if (isDetailsOutside() || activeTab() === 'DETAILS') {
          <div class="schedule-content schedule-content_details">
            <div class="content-inner">
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.BASE_RATE' | translate }}</p>
                <p class="preview-value">{{ mockProduct.interest }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name max-width-text">{{ 'CALCULATE_COMMISSION' | translate }}</p>
                <p class="preview-value">{{ mockProduct.issueCommissionRate }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.TERMS' | translate }}</p>
                <p class="preview-value">{{ previewValue().term }} днів</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.FIRST_PAYMENT' | translate }}</p>
                <p class="preview-value">{{ previewValue().firstPaymentPeriodAmount }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.PAYMENTS_AMOUNT' | translate }}</p>
                <p class="preview-value">{{ previewValue().percentByTerm }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">
                  <span>
                    {{ 'CALCULATE.XIRR' | translate }}
                    <span
                      [matTooltip]="'CALCULATE.XIRR_TOOLTIP' | translate"
                      class="preview-icon"
                      matTooltipClass="preview-tooltip"
                      matTooltipPosition="above"
                      >!</span
                    ></span
                  >
                </p>
                <p class="preview-value">{{ previewValue().details.firstPayment.realPercentPerYear }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.PAYMENTS_COUNT' | translate }}</p>
                <p class="preview-value">{{ paymentsQuantity }}</p>
              </div>
              <div class="preview-row">
                <p class="preview-name max-width-text">{{ 'CALCULATE.PERCENT_AMOUNT' | translate: { term: mockProduct.fullTerm } }}</p>
                <p class="preview-value">{{ previewValue().percentAmount }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE.TOTAL_AMOUNT' | translate: { term: mockProduct.fullTerm } }}</p>
                <p class="preview-value">{{ previewValue().totalAmount }} грн</p>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
